import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";

import useLenis, { scrollToId } from "@/lib/useLenis";
import useSEO from "@/lib/useSEO";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import EditorialMarquee from "@/sections/EditorialMarquee";
import Manifesto from "@/sections/Manifesto";
import Packages from "@/sections/Packages";
import Journal from "@/sections/Journal";
import FAQ from "@/sections/FAQ";
import Testimonials from "@/sections/Testimonials";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";
import Journeys from "@/pages/Journeys";
import PackageDetail from "@/pages/PackageDetail";
import AdminPage from "@/pages/admin/AdminPage";
import NotFound from "@/pages/NotFound";
import IndiaLanding from "@/pages/IndiaLanding";
import { JournalIndex, ArticlePage } from "@/pages/Journal";
import AuthCallback from "@/pages/admin/AuthCallback";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Home() {
  useLenis();
  useSEO({ path: "/" });
  const location = useLocation();
  const [selectedInterest, setSelectedInterest] = useState("");

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const t = setTimeout(() => scrollToId(target), 350);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <div className="App relative">
      <div className="grain" aria-hidden />
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <Packages onSelect={setSelectedInterest} />
        <Journal />
        <FAQ />
        <Testimonials />
        <Contact
          selectedInterest={selectedInterest}
          setSelectedInterest={setSelectedInterest}
        />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/journeys" element={<Journeys />} />
        <Route path="/journeys/:slug" element={<PackageDetail />} />
        <Route path="/bhutan-tour-packages-from-india" element={<IndiaLanding />} />
        <Route path="/journal" element={<JournalIndex />} />
        <Route path="/journal/:slug" element={<ArticlePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isAdmin && <WhatsAppButton />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
